import React, { FC, useEffect, useState, useCallback } from 'react'
import DOMPurify from 'dompurify'
import { KTSVG } from '../../_metronic/helpers'
import axios from 'axios'
import { useTable, useSortBy } from 'react-table'
import { Tableloading } from './Tableloading'
import CountUp from 'react-countup'
type Props = {
  rowdata: any
  tabledata2: []
  columndata2: any
  tablename: string
  filteredsubdata: any
  paymenttypedetails?: any
  table2loaded: boolean | undefined
  table1loaded: boolean | undefined
  filteredtablesubData: any
}
const API_URL = process.env.REACT_APP_API_URL
const CustomTableStyle: React.CSSProperties = {
  borderCollapse: 'collapse',
  borderSpacing: 0,

};

const CustomTableRowStyle: React.CSSProperties = {
  border: 'none',
  margin: 0,
  padding: 0,
};

const CustomTableCellStyle: React.CSSProperties = {
  border: 'none',
  margin: 0,
  padding: '0.1rem 0.1rem',
};
const Mainsubtable: React.FC<Props> = ({
  rowdata,
  tabledata2,
  columndata2,
  tablename,
  filteredsubdata,
  paymenttypedetails,
  table2loaded,
  table1loaded,
  filteredtablesubData,
}) => {
  const CURRENCY_APP = process.env.REACT_APP_CURRENCY

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow, state } = useTable(
    {
      columns: columndata2 as any,
      data: filteredtablesubData,

      defaultColumn: {},
      initialState: {},
    },
    useSortBy
  )



  return (
    <>
      <div className='card bg-light'>
        {/* begin::Header */}
        <div className='card-header border-0 pt-5'>
          <h3 className='card-title align-items-start flex-column'>
            <span className='card-label fw-bolder fs-5 mb-1'>{tablename}</span>

            {typeof filteredsubdata !== 'number' ? null : (
              <span className='text-muted mt-1 fw-bold fs-7'>
                {filteredsubdata === 1
                  ? `${filteredsubdata} entry made`
                  : `${filteredsubdata} entries made`}
              </span>
            )}
          </h3>
          <div className='card-toolbar'>
            {/* begin::Menu */}
            <button
              type='button'
              className='btn btn-sm btn-icon btn-color-primary btn-active-light-primary'
              data-kt-menu-trigger='click'
              data-kt-menu-placement='bottom-end'
              data-kt-menu-flip='top-end'
            >
              <KTSVG path='/media/icons/duotune/general/gen024.svg' className='svg-icon-2' />
            </button>
          </div>
        </div>
        {/* end::Header */}
        {/* begin::Body */}

        <div className='card-body py-3'>
          {paymenttypedetails ? (
            <div className='row mt-5 mb-5'>
              <div className='col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start'></div>

              <div className='col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end'>
                <div className='mb-2'>
                  <div className='d-flex align-items-center text-nowrap'>
                    <span className='text-primary fw-bolder fs-7 text-uppercase gs-0'>
                      PAYMENT MODE
                    </span>
                    <span className='h-50px border-gray-200 border-start mx-2'></span>
                    <div className='d-flex justify-content-start flex-column'>
                      <span className='fw-bold d-block fs-7 text-muted'>

                        <table style={CustomTableStyle}>
                          <tbody>
                            {paymenttypedetails
                              .filter(
                                (x: any) =>
                                  x.total_amount > 0
                              )
                              .map((k: any, keys: any) => (
                                <tr key={keys + k.payment_type_name} style={CustomTableRowStyle}>
                                  <td style={CustomTableCellStyle}>
                                    <span
                                      className={`${k.payment_type_name === 'MPESA'
                                        ? 'badge badge-light-success'
                                        : k.payment_type_name === 'CHEQUE'
                                          ? 'badge badge-light-warning'
                                          : k.payment_type_name === 'MPESACASH'
                                            ? 'badge badge-light-info'
                                            : 'badge badge-light-primary'
                                        }`}
                                    >
                                      {k.payment_type_name}
                                    </span>
                                  </td>
                                  <td style={CustomTableCellStyle}>
                                    <span className='h-20px border-gray-200 border-start mx-2'></span>
                                    <CountUp
                                      className='text-bold'
                                      end={k.total_amount}
                                      duration={2}
                                      decimals={2}
                                      separator=','
                                    />{' '}
                                    <sup>{CURRENCY_APP}</sup>
                                  </td>
                                </tr>
                              ))}
                          </tbody>
                        </table>

                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <></>
          )}
          {/* begin::Table container */}
          {typeof filteredsubdata == 'number' ? (
            <div className='table-responsive'>
              <table
                {...getTableProps()}
                className='table align-middle table-row-dashed table-row-gray-300 fs-6 gy-5 dataTable no-footer '
              >
                <thead className='border-bottom border-gray-200'>
                  {headerGroups.map((headerGroup, keys) => (
                    <tr
                      {...headerGroup.getHeaderGroupProps()}
                      className='text-start text-muted fw-bolder fs-7 text-uppercase gs-0'
                      key={keys + Date.now()}

                    >
                      {headerGroup.headers.map((column, key) => (
                        <th
                          {...column.getHeaderProps(column.getSortByToggleProps())}
                          key={key + Date.now()}
                        >
                          {column.render('Header')}
                          <span>
                            {column.isSorted ? (
                              column.isSortedDesc ? (
                                <>
                                  <span className='svg-icon svg-icon-primary svg-icon-1x'>
                                    <svg
                                      xmlns='http://www.w3.org/2000/svg'
                                      width='24'
                                      height='24'
                                      viewBox='0 0 24 24'
                                    >
                                      <g fill='none' fillRule='evenodd'>
                                        <path d='M0 0L24 0 24 24 0 24z'></path>
                                        <path
                                          fill='#009ef7'
                                          fillRule='nonzero'
                                          d='M17.293 8.293a1 1 0 111.414 1.414l-6 6a1 1 0 01-1.383.03l-6-5.5a1 1 0 111.352-1.474l5.294 4.853 5.323-5.323z'
                                        ></path>
                                      </g>
                                    </svg>
                                  </span>
                                </>
                              ) : (
                                <>
                                  <span className='svg-icon svg-icon-primary svg-icon-1x'>
                                    <svg
                                      xmlns='http://www.w3.org/2000/svg'
                                      width='24'
                                      height='24'
                                      viewBox='0 0 24 24'
                                    >
                                      <g fill='none' fillRule='evenodd'>
                                        <path d='M0 0L24 0 24 24 0 24z'></path>
                                        <path
                                          fill='#009ef7'
                                          fillRule='nonzero'
                                          d='M6.707 15.707a1 1 0 11-1.414-1.414l6-6a1 1 0 011.383-.03l6 5.5a1 1 0 11-1.352 1.474l-5.294-4.853-5.323 5.323z'
                                        ></path>
                                      </g>
                                    </svg>
                                  </span>
                                </>
                              )
                            ) : (
                              ''
                            )}
                          </span>
                        </th>
                      ))}
                    </tr>
                  ))}
                </thead>
                <tbody {...getTableBodyProps()} className='text-gray-600 fw-bold'>
                  {table2loaded ? (
                    <>
                      {rows.length > 0 ? (
                        rows.map((row, morekeys) => {
                          prepareRow(row)
                          return (
                            <React.Fragment key={row.getRowProps().key}>
                              <tr {...row.getRowProps()} key={morekeys + Date.now()}>
                                {row.cells.map((cell, key) => {
                                  return (
                                    <td {...cell.getCellProps()} key={key + Date.now()}>
                                      {cell.render('Cell')}
                                    </td>
                                  )
                                })}
                              </tr>
                            </React.Fragment>
                          )
                        })
                      ) : (
                        <tr>
                          <td colSpan={columndata2.length}>
                            <div className='d-flex text-center w-100 align-content-center justify-content-center'>
                              No matching records found
                            </div>
                          </td>
                        </tr>
                      )}
                    </>
                  ) : (
                    <>
                      <tr>
                        <td colSpan={columndata2.length}>
                          <div className='d-flex text-center w-100 align-content-center justify-content-center m-3'>
                            <Tableloading />
                          </div>
                        </td>
                      </tr>
                    </>
                  )}
                </tbody>
              </table>
            </div>
          ) : (
            <div className='mb-5'>
              <div dangerouslySetInnerHTML={{ __html: filteredtablesubData }} />
            </div>
          )}

          {/* end::Table container */}
        </div>

        {/* begin::Body */}
      </div>
    </>
  )
}

export { Mainsubtable }
